import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Email Successfully Confirmed!", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Your alias email has been successfully added to the list.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_commonDialog = _resolveComponent("commonDialog")!

  return ($setup.isShowDialog)
    ? (_openBlock(), _createBlock(_component_commonDialog, {
        key: 0,
        onClickBackButton: $setup.onClickCloseTab,
        width: "478px",
        "max-width": "100%",
        height: "auto",
        isShowHeader: false,
        isShowBackButton: false,
        className: ['delete_invite_modal']
      }, {
        body: _withCtx(() => [
          _createVNode(_component_v_card, { class: "delete_invitees" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("img", {
                  src: require('@/assets/images/email-success.png'),
                  alt: ""
                }, null, 8, _hoisted_2)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createVNode(_component_v_btn, {
                  class: "button button-orange",
                  onClick: $setup.onClickCloseTab
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" CONTINUE ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClickBackButton"]))
    : _createCommentVNode("", true)
}